import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toEntityName',
  standalone: true,
})
export class ToEntityNamePipe implements PipeTransform {
  transform(entity: string): string {
    switch (entity) {
      case 'header':
        return 'Header';
      case 'banner':
        return 'Banner';
      case 'footer_addressArea':
      case 'footer_logoArea':
      case 'footer_paymentArea':
      case 'footer_linkArea':
        return 'Footer';
      case 'loginLogout':
        return 'Login/Logout';
      case 'generalArea':
        return 'Allgemein';
      case 'salutation':
        return 'Anrede';
      case 'privateArea':
        return 'Persönlicher Bereich';
      case 'shoppingCart':
        return 'Warenkorb';
      case 'corporateDesign':
        return 'Corporate Design';
      case 'ticket':
        return 'Ticket';
    }
    return entity;
  }
}
